import HTMLReactParser from 'html-react-parser';

import * as St from './WarrantyDetailsModal.styles';
import { selectWarrantyInfo } from './WarrantyDetailsModal.utils';

import { OptionalProduct } from '~/core/models';

type WarrantyDetailsModalProps = {
  onClose: () => void;
  onConfirm: () => void;
  warrantyCandidate?: OptionalProduct;
};

const WarrantyDetailsModal = ({
  onClose,
  onConfirm,
  warrantyCandidate,
}: WarrantyDetailsModalProps) => {
  const selectedTitle = selectWarrantyInfo('title', warrantyCandidate);

  return (
    <St.WarningDetailModal
      open={!!warrantyCandidate}
      closable={false}
      footer={
        <St.ButtonsContainer>
          <St.Button onClick={onClose} data-style="warning-secondary">
            {'Cancel'}
          </St.Button>
          <St.Button onClick={onConfirm} data-style="warning-primary">
            {'Add'}
          </St.Button>
        </St.ButtonsContainer>
      }
    >
      <St.WarningDetailModalTitle>
        {selectedTitle === 'GRANITE GOLD CABINET PROTECTION PLAN' ? (
          <>
            GRANITE GOLD<sup>®</sup> CABINET PROTECTION PLAN
          </>
        ) : (
          <>
            GRANITE GOLD<sup>®</sup> PROTECTION PLAN
          </>
        )}
      </St.WarningDetailModalTitle>
      {HTMLReactParser(selectWarrantyInfo('content', warrantyCandidate))}
    </St.WarningDetailModal>
  );
};

export default WarrantyDetailsModal;
